import { render, staticRenderFns } from "./quote-buy.vue?vue&type=template&id=5af5be5d&scoped=true&"
import script from "./quote-buy.vue?vue&type=script&lang=js&"
export * from "./quote-buy.vue?vue&type=script&lang=js&"
import style0 from "./quote-buy.vue?vue&type=style&index=0&id=5af5be5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5be5d",
  null
  
)

export default component.exports